import { render, staticRenderFns } from "./shoporder.vue?vue&type=template&id=96e7b0e6&scoped=true&"
import script from "./shoporder.vue?vue&type=script&lang=js&"
export * from "./shoporder.vue?vue&type=script&lang=js&"
import style0 from "./shoporder.vue?vue&type=style&index=0&id=96e7b0e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e7b0e6",
  null
  
)

export default component.exports